import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomePolicy } from '@models/swagger';
import { PutPolicyParams } from './service';

export enum PutPolicyActions {
  Failure = '[Policy PutPolicy] Failure',
  Request = '[Policy PutPolicy] Request',
  Success = '[Policy PutPolicy] Success',
  Reset = '[Policy PutPolicy] Reset',
}

export const PutPolicyFailure = createAction(PutPolicyActions.Failure, props<{ error: HttpErrorResponse }>());

export const PutPolicyRequest = createAction(
  PutPolicyActions.Request,
  props<{ body: HomePolicy; parameters: PutPolicyParams }>()
);

export const PutPolicySuccess = createAction(PutPolicyActions.Success, props<{ data: HomePolicy }>());

export const PutPolicyReset = createAction(PutPolicyActions.Reset);
